/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M228.316 382.209c.485.565 1.077.97 1.59 1.509.43.458.889.862 1.374 1.293 3.072 2.883 6.494 5.282 10.294 6.952.404.162.808.243 1.24.405 4.203 1.643 8.65 2.694 13.257 2.694 4.608 0 9.055-1.05 13.258-2.694.432-.162.863-.243 1.267-.431 3.773-1.644 7.141-4.016 10.213-6.872.512-.485.997-.916 1.482-1.428.485-.512 1.051-.89 1.536-1.428l130.587-153.897c13.016-15.306 11.13-38.265-4.204-51.254-15.252-13.042-38.292-11.156-51.254 4.204l-66.506 78.363V38.36c0-20.076-16.303-36.352-36.379-36.352-20.075 0-36.352 16.276-36.352 36.352v221.157l-66.317-78.255c-13.043-15.306-35.948-17.22-51.308-4.23-15.306 12.988-17.192 35.947-4.23 51.28L228.315 382.21zM406.92 436.394H105.379C85.276 436.394 69 452.67 69 472.774c0 20.075 16.276 36.351 36.379 36.351H406.92c20.076 0 36.379-16.276 36.379-36.352 0-20.103-16.303-36.379-36.379-36.379" />
    </g>
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconDownload = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconDownload.defaultProps = {
  theme,
};
IconDownload.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconDownload.displayName = 'IconDownload';
export { IconDownload };
